import React, { useState, useEffect } from 'react'
import Announcements from '../announcements'
import GlobalImports from '../shared/GlobalImports'

export default function Index({
  appProps, admin, getInvoicingTenantsPath, brandWebsiteUrl, helpCenterUrl,
  accountsRenewingToday, supportPhoneUrl, promoArea,
  announcements, groups, selectedColumns
}) {
  const [loading, setLoading]                   = useState(false)
  const [invoicingTenants, setInvoicingTenants] = useState(false)

  const statuses = [0, 10, 20, 30, 40, 50, 60]

  useEffect( ()=> {
    getIncoicingStatus()
  },[])

  function getIncoicingStatus() {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: getInvoicingTenantsPath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        let fetchedStatuses = Object.keys(res.items)
        fetchedStatuses = fetchedStatuses.map( s => {
          const statusCode = parseInt(s)
          return { key: statusCode, position: statuses.indexOf(statusCode), count: res.items[s] }
        }).filter(status => status.position >= 0)
          .sort( (a, b) => a.position - b.position)
        setInvoicingTenants(fetchedStatuses)
      }
    })
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light fa-home` }/>
              <div className='flex-box flex-column'>
                <h1 className='page-header-title'>
                  { Support.translations.home.home_page}
                </h1>
                <div className='m-t-5'>
                  { admin.name || admin.email }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Announcements
        announcements={ announcements }
        groups={ groups }
        selectedColumns={ selectedColumns }
        readOnly
      />

      { promoArea &&
        <div dangerouslySetInnerHTML={{ __html: promoArea  }} />
      }

      { invoicingTenants &&
        <div className="card">
          <div className="card-content">
            <div className="card-title">{ Support.translations.home.invoicing_status }</div>
            <div className="card-body m-t-30">

              <div className="flex-box flex-column">
                { invoicingTenants.map( (tenant, index)=> {
                    return (
                      <div key={index} className='flex-box items-center content-space-between p-t-10 p-b-10' style={{ borderBottom: '1px solid #dddddd' }}>
                        <div className=''>{ ReactiveCore.translations.invoicing_onboarding.status[tenant.key] }</div>
                        <div className='bold'>{ tenant.count }</div>
                      </div>
                    )
                  })
                }
              </div>

            </div>
          </div>
        </div>
      }

      <div className='card'>
        <div className='card-content'>
          <div className='card-title m-b-20'>
            { Support.translations.home.useful_links }
          </div>

          <div className='card-body'>
            <div className='flex-box flex-column'>
              <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
                <a
                  href={ helpCenterUrl }
                  target='_blank'
                  className='flex-box items-center content-space-between'
                >
                  <div>
                    <i className='fa fa-circle-info p-r-20' />
                    { Support.translations.home.help_center }
                  </div>
                  <div>
                    <i className='fa fa-chevron-right' />
                  </div>
                </a>
              </div>
            </div>

            <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
              <a
                href={ `tel:${ supportPhoneUrl }` }
                target='_blank'
                className='flex-box items-center content-space-between'
              >
                <div>
                  <i className='fa fa-phone p-r-20' />
                  { Support.translations.home.support_phone }
                </div>
                <div>
                  <i className='fa fa-chevron-right' />
                </div>
              </a>
            </div>

            <div style={{ padding: '20px 0', borderBottom: '1px solid #ddd' }}>
              <a
                href={ brandWebsiteUrl }
                target='_blank'
                className='flex-box items-center content-space-between'
              >
                <div>
                  <i className='fa fa-desktop p-r-20' />
                  { Support.translations.home.brand_website }
                </div>
                <div>
                  <i className='fa fa-chevron-right' />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      { !!accountsRenewingToday.length &&
        <div className='card'>
          <div className='card-content'>
            <div className='card-title m-b-10'>
              { Support.translations.account.accounts_to_be_billed_today }
            </div>

            <div className='card-body'>
              <table className='responsive-table'>
                <thead>
                  <tr>
                    <th>{ Support.translations.columns.storeName }</th>
                    <th>{ Support.translations.columns.merchant }</th>
                    <th>{ Support.translations.columns.paymentType }</th>
                    <th>{ Support.translations.columns.flavour }</th>
                    <th>{ Support.translations.columns.plan }</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  { accountsRenewingToday.map((account, idx) => (
                    <tr key={ idx }>
                      <td>{ account.name }</td>
                      <td>{ account.merchant }</td>
                      <td>{ account.payment_type }</td>
                      <td>{ Support.translations.module_names[account.flavour.toLowerCase()] }</td>
                      <td>{ account.plan }</td>
                      <td>
                        <div className='flex-box items-center content-end'>
                          <div
                            style={{ cursor: 'pointer' }}
                            onClick={ _e => window.open(account.path, '_blank') }
                          >
                            <i className='fa-light fa-eye' />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      <GlobalImports appProps={ appProps } />
    </>
  )
}
